export const storageKey = {
    enumData: 'enumData',
    instituteToken: 'instituteToken',
    instituteEnumData: 'instituteEnumData',
    studentEnumData: 'studentEnumData',
    admissionEnumData: 'admissionEnumData',
    cityState: 'cityStateData',
};
